<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <LoadCard v-if="load"></LoadCard>

        <DashboardCard v-else>
            <blockquote class="card-blockquote">
                <b-icon icon="person-dash-fill" class="icone-files"></b-icon>
                <p>Denuncias de Ley Karin</p>

                <footer>
                    <h2>{{ getCount }}</h2>
                </footer>

            </blockquote>
        </DashboardCard>
    </div>
</template>
<script>
//signal R
import { hub } from '@/plugins/signalR/index.js';
import { ReceiveHubs, Hubs as namesHub } from '@/plugins/enums/index.js';

//alerta
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import LoadCard from '@/components/shared/Load-card.vue'
import DashboardCard from '@/components/shared/Dashboard-card.vue'

//mixin
import { dashboardGraph } from '@/plugins/mixin/index.js'

export default {
    name: 'KarinDenunciationCountGraph',

    mixins: [dashboardGraph],

    data() {
        return {
            count: 0,
            load: true,

            connection: null
        }
    },

    components: {
        AlertDismiss,
        LoadCard,
        DashboardCard
    },

    async created() {
        this.connection = hub.getInstance(namesHub.karinDenunciationHub)
        
        await this.connection.start();
        
        this.countKarinDenunciationsSignalR(this.connection);
    },

    beforeDestroy() {
        this.connection.off(ReceiveHubs.countKarinDenunciation);
    },

    computed: {
        getCount() {
            return this.count;
        }
    },

    methods: {
        countKarinDenunciationsSignalR(connection) {
            connection.on(ReceiveHubs.countKarinDenunciation, (count) => {
               try {
                    if (this.getGraph.mixinItUpdates) { this.count = count; }
                } catch (error) {
                    this.$refs.alertDismiss.showAlert("Error en la gráfica que representa las cantidades de denuncias de la Ley Karin");
                }

                this.load = false;
            });
        }
    },
}
</script>
<style scoped>
</style>
